// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_93444fe79c--checkbox--oMeNF","box":"_93444fe79c--box--aD_nX","label":"_93444fe79c--label--iT_qr"};